<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>产品型号</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <div>
            <Button type="primary" icon="plus-round" @click="addFirmware" v-if="authList.indexOf('013001') !== -1">添加</Button>
            <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('013002') !== -1">删除</Button>
          </div>
        </div>

        <Table border height="520" ref="product_model_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
        <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>
    <Modal
      v-model="openSimple"
      title="添加产品型号"
      @on-ok="sureAdd"
      @on-cancel="cancelAdd">
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 70px;text-align: right;"><span style="color: red;">*</span>产品标识</span>
        <InputNumber style="width: 300px;" :max=99 :min=1 v-model="formData.productIdentity"/>
      </p>
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 70px;text-align: right;"><span style="color: red;">*</span>产品名称</span>
        <Input v-model="formData.productName" style="width: 300px;"/>
      </p>
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 70px;text-align: right;"><span style="color: red;">*</span>产品型号</span>
        <Input v-model="formData.productModelName" style="width: 300px;"/>
      </p>
      <p>
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 70px;text-align: right;vertical-align: top;">备注</span>
        <Input type="textarea" :rows="4" v-model="formData.memo" style="width: 300px;resize: none;" :maxlength=32 />
      </p>
    </Modal>

    <Modal
      v-model="deleteProductModel"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除产品型号？</p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nError, nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'product-model',
  data () {
    return {
      authList: '',
      total: 0,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '产品标识',
          key: 'productIdentity',
          align: 'center'
        }, {
          title: '产品名称',
          key: 'productName',
          align: 'center'
        }, {
          title: '产品型号',
          key: 'productModelName',
          align: 'center'
        }, {
          title: '备注',
          key: 'memo',
          align: 'center'
        }, {
          title: '创建时间',
          key: 'createTime',
          align: 'center'
        }, {
          title: '操作',
          width: 180,
          key: 'operation',
          align: 'center',
          render: (h, params) => {
            if (params.row.authStatus) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.deleteProModel(params.row.id)
                    }
                  }
                }, '删除')
              ])
            }
          }
        }
      ],
      reqbody: {
        pageSize: 10,
        pageNo: 1
      },
      formData: {
        productIdentity: 1,
        productName: '',
        productModelName: '',
        memo: '',
      },
      deleteDevId: {},
      batchId: {
        ids: ''
      },
      tableData: [],
      openSimple: false,
      deleteProductModel: false
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getProductModelPage()
  },
  methods: {
    getProductModelPage () {
      this.$axios.post(`${httpUrl.url}/manage/productModel/getPage`, this.reqbody)
        .then(res => {
          let data = res.data.data
          data.list.map(v => {
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            } else {
              v.createTime = '--'
            }
          })
          if (this.authList.indexOf('013002') !== -1) {
            data.list.map(v => {
              v.authStatus = true
            })
          } else {
            data.list.map(v => {
              v.authStatus = false
            })
          }
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    addFirmware () {
      this.openSimple = true
    },
    sureAdd () {
      if (!this.formData.productIdentity) {
        nError('产品标识不能为空')
        return false
      }
      if (!this.formData.productName) {
        nError('产品名称不能为空')
        return false
      }
      if (!this.formData.productModelName) {
        nError('产品型号不能为空')
        return false
      }
      let setData = {
        productIdentity: this.formData.productIdentity,
        productName: this.formData.productName,
        productModelName: this.formData.productModelName,
        memo: this.formData.memo,
      }
      if (setData.productIdentity < 10) {
        setData.productIdentity = '0' + setData.productIdentity
      } else {
        setData.productIdentity = setData.productIdentity.toString()
      }
      this.$axios.post(`${httpUrl.url}/manage/productModel/add`, setData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.formData = {
              productIdentity: 1,
              productName: '',
              productModelName: '',
              memo: '',
            }
            this.getProductModelPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancelAdd () {
      this.formData = {
        productIdentity: '',
        productName: '',
        productModelName: '',
        memo: '',
      }
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择产品型号')
        return false
      }
      this.deleteProModel(this.batchId.ids)
    },
    deleteProModel (id) {
      this.deleteProductModel = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/productModel/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.deleteProductModel = false
            this.getProductModelPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.deleteProductModel = false
    },
    sercher () {
      this.getProductModelPage()
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getProductModelPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getProductModelPage()
    }
  },
  watch: {
    openSimple (v) {
      if (v === false) {
        this.formData.productIdentity = 1
      }
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/factory-allocation/product-model.vue